import { PromotionKind } from "common/types/promotions";

import { useFeatures } from "client/clinics/hooks";

import RebatePage from "./RebatePage";
import PromotionPage from "./PromotionPage";

const RebatePageSwitch = () =>
  useFeatures().PROMOTION_PAGES_USE_PRODUCT_CARDS ? (
    <PromotionPage kind={PromotionKind.Rebate} />
  ) : (
    <RebatePage />
  );

export default RebatePageSwitch;
